/**
 * Single source of truth for prefers-reduced-motion. Gameplay, audio and
 * haptics never read this — only decorative animation does: path glow/width
 * easing, tile press pulses, win particles, and screen transitions.
 */

const query = window.matchMedia?.("(prefers-reduced-motion: reduce)");

export function reducedMotion(): boolean {
  return query?.matches ?? false;
}

export function onReducedMotionChange(cb: (reduced: boolean) => void): void {
  query?.addEventListener?.("change", () => cb(query.matches));
}
